"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecoveryOverview = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const hooks_1 = require("../../shared/hooks");
const react_i18next_1 = require("react-i18next");
const CollapseRecoveryMobile_1 = __importDefault(require("./CollapseRecoveryMobile"));
const RecoveryWeekPreviewTable_1 = __importDefault(require("./RecoveryWeekPreviewTable"));
exports.RecoveryOverview = (0, react_1.memo)(({ recoveryMap, startDay, onHeaderClick, isAverage }) => {
    const { isMobile } = (0, hooks_1.useRWD)();
    const { t } = (0, react_i18next_1.useTranslation)();
    return isMobile ? ((0, jsx_runtime_1.jsx)(CollapseRecoveryMobile_1.default, { title: t("recovery.recovery"), valuesMap: recoveryMap, startDay: startDay, onHeaderClick: onHeaderClick }, "mobile_recovery")) : ((0, jsx_runtime_1.jsx)(RecoveryWeekPreviewTable_1.default, { title: t("recovery.recovery"), valuesMap: recoveryMap, startDay: startDay, isAverage: isAverage, onHeaderClick: onHeaderClick }, "web_recovery"));
});
//# sourceMappingURL=RecoveryOverview.js.map